const asBoolean = (val) => val === '1'

export const useBannerRemoteConfig = () => {
  const settings = window?.gon?.setting

  const serializedData = {
    is_web_subscription_enabled: asBoolean(
      settings?.is_web_subscription_enabled
    ),
    is_web_phone_verification_enabled: asBoolean(
      settings?.is_web_phone_verification_enabled
    ),
    is_web_locale_chinese_korean_enabled: asBoolean(
      settings?.is_web_locale_chinese_korean_enabled
    ),
    is_facebook_login_broken: asBoolean(settings?.is_facebook_login_broken),
  }

  return {
    data: serializedData,
  }
}
